<template>
  <OrCardV3 class="flex w-full flex-row !gap-[0px] theme-background-surface-variant dark:theme-background-surface-variant-dark typography-caption-bold text-on-background dark:text-on-background-dark">
    <div class="flex w-3/12 items-center px-sm">
      <OrTextV3
        :text="$t('queuesTable.name')"
      />
    </div>
    <div class="flex w-1/5 items-center px-sm">
      <OrTextV3
        :text="$t('queuesTable.returnPolicy')"
      />
    </div>
    <div class="flex w-1/5 items-center px-sm">
      <OrTextV3
        :text="$t('queuesTable.retentionTime')"
      />
    </div>
    <div class="flex w-1/5 items-center px-sm">
      <OrTextV3
        :text="$t('queuesTable.dateCreated')"
      />
    </div>
    <div class="flex items-center px-sm">
      {{ $t('queuesTable.actions') }}
    </div>
  </OrCardV3>
</template>
<script lang="ts">
import { OrCardV3, OrTextV3 } from '@onereach/ui-components';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'QueuesListHeader',
  components: {
    OrCardV3,
    OrTextV3,
  },
});
</script>
